var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinaleHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3129.1 2778.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1491.2,236.3c26.6,26.9,51.2,56.6,73.2,87.4,90.7-124,218.5-220.5,363.3-273,382-138.6,833.5,15.7,1051.1,355.9,127.6,199.4,184.3,484,129.5,715.5-96.8,408.8-449.8,807.8-757.4,1079.9-245.3,216.9-515.5,405.3-794.5,576.1-277.9-173-548.3-360.4-793.1-578.2C456.2,1926.8,103.8,1523.3,16.6,1111.3c-50.5-238.7,17.4-534.6,156.9-733.6C470-45.2,1117.1-141.9,1491.2,236.3ZM1563.3,428.8c-67-137.1-195.8-247.7-334.6-309C882.2-33.4,457,89.4,232.3,388.2,85.9,582.9,17.9,881.4,73.8,1119.2c104.9,446.7,517.2,874.5,862.7,1157.3,184.4,150.9,392.8,300.5,596.7,423.8,4.8,2.9,20.4,13.2,24.6,13,354.2-219,697.8-469.9,986.1-771.7,218.1-228.2,466.8-563.6,522.3-880.4,33.4-191-20.3-437.9-119.5-603.8C2757.7,141.4,2360.1-14.7,2003.8,82.9c-165.3,45.3-329.2,158.8-417.8,306.7-2.2,3.7-20.6,40.8-22.7,39.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinaleHeart);
export default __webpack_public_path__ + "static/media/finale-heart.fe78b14ed7c3708e78b063c9ec16fd21.svg";
export { ForwardRef as ReactComponent };